import { forwardRef } from 'react';
import { MEAL_CONFIG, MEAL_TYPE_MAP } from '../../config/meal-config';
import ActionStatusText from '../ui/ActionStatusText';

const DiaryMenu = forwardRef(
    ({ entryType, isExercise, isFavorite, isAddedMeal, isDeletingFavorite, onMenuClick }, ref) => {
        const mealTypeKey = !isExercise ? MEAL_TYPE_MAP[entryType] : null;
        const mealType = mealTypeKey ? MEAL_CONFIG[mealTypeKey] : null;

        return (
            <ul id="diary-menu-dropdown" ref={ref}>
                {!isAddedMeal && (
                    <>
                        <li onClick={() => onMenuClick('copy')}>
                            <img src="/assets/images/diary-icons/plus-gray.svg" alt="" />
                            <span>Kopiera till...</span>
                        </li>

                        <li onClick={() => onMenuClick('move')}>
                            <img src="/assets/images/diary-icons/arrow-right.svg" alt="" />
                            <span>Flytta till...</span>
                        </li>

                        <li
                            onClick={() => {
                                if (isDeletingFavorite) return;

                                onMenuClick(isFavorite ? 'unfavorite' : 'favorite');
                            }}
                            className={isDeletingFavorite ? 'disabled' : ''}
                        >
                            <img
                                src={
                                    isFavorite
                                        ? '/assets/images/diary-icons/heart-pink.svg'
                                        : '/assets/images/diary-icons/heart-gray.svg'
                                }
                                alt=""
                            />

                            <ActionStatusText
                                isProcessing={isDeletingFavorite}
                                processingLabel="Tar bort favorit"
                                defaultLabel={isFavorite ? 'Ta bort favorit' : 'Skapa favorit'}
                            />
                        </li>

                        <li onClick={() => onMenuClick('edit')}>
                            <img src="/assets/images/diary-icons/pen-gray.svg" alt="" />
                            <span>Redigera {isExercise ? 'träningen' : 'måltiden'}</span>
                        </li>

                        {!isExercise && mealType && (
                            <>
                                <li onClick={() => onMenuClick('nutrition')}>
                                    <img src="/assets/images/diary-icons/chart-line-up-gray.svg" alt="" />
                                    <span>Visa näringsinfo</span>
                                </li>

                                <li onClick={() => onMenuClick('addMealType')}>
                                    <img src={mealType.icon_gray} alt="" />
                                    <span>Lägg till {mealType.title.toLowerCase()}</span>
                                </li>
                            </>
                        )}
                    </>
                )}

                <li onClick={() => onMenuClick('delete')}>
                    <img src="/assets/images/diary-icons/times-pink.svg" alt="" />
                    <span>Radera {isExercise ? 'träningen' : 'måltiden'}</span>
                </li>
            </ul>
        );
    }
);

export default DiaryMenu;
